module.exports = __webpack_public_path__ + "img/web-3.55030e45.svg";